<template>
  <View gap="xl" direction="column">
    <View gap="md" direction="column" align="center">
      <IconTile icon="check-circle" size="large" shape="rounded" color="green" :colored-icon="true" />

      <Text variant="h2" align="center">We've sent your application invite to {{ renterName }}!</Text>

      <Text variant="body-large" align="center" color="secondary">
        We will notify you when {{ renterName }} has completed the application
      </Text>
    </View>

    <Card variant="outline">
      <View gap="md" direction="column">
        <Text variant="h4">What happens next?</Text>

        <View v-for="(item, index) in items" :key="item.title" gap="md" direction="row">
          <View align="center" justify="center" class="item-number">{{ index + 1 }}</View>
          <View gap="xs" direction="column">
            <Text variant="h4">{{ item.title }}</Text>
            <Text variant="body-medium" color="secondary">
              {{ item.description }}
            </Text>
          </View>
        </View>
      </View>
    </Card>
  </View>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Card, IconTile, Text, View } from '@tallo/design-system';

const props = defineProps<{ renterName: string }>();

const items = computed<{ title: string; description: string }[]>(() => [
  {
    title: `Tallo will send ${props.renterName} reminders`,
    description: `${props.renterName} will receive reminders and guidance throughout the process.`,
  },
  {
    title: `Track the application`,
    description: `You can monitor the status of ${props.renterName}'s application in their renter profile.`,
  },
  {
    title: 'Receive notification when complete',
    description: `Once the application is finished, Tallo will notify you. From there, you can approve or decline, and we'll handle the rest.`,
  },
]);
</script>

<style scoped lang="scss">
.item-number {
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  background-color: var(--t-color-neutral-200);
  border-radius: var(--t-border-radius-sm);
}
</style>
